var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSubtitles = function SvgSubtitles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12A3.75 3.75 0 0 1 9 8.25h.219a3 3 0 0 1 1.341.317l.275.137a.75.75 0 1 1-.67 1.342l-.275-.138a1.5 1.5 0 0 0-.671-.158H9a2.25 2.25 0 0 0 0 4.5h.219a1.5 1.5 0 0 0 .67-.158l.276-.138a.75.75 0 1 1 .67 1.342l-.275.137a3 3 0 0 1-1.341.317H9A3.75 3.75 0 0 1 5.25 12ZM16.5 8.25a3.75 3.75 0 1 0 0 7.5h.219a3 3 0 0 0 1.341-.317l.275-.137a.75.75 0 1 0-.67-1.342l-.275.138a1.5 1.5 0 0 1-.671.158H16.5a2.25 2.25 0 0 1 0-4.5h.219a1.5 1.5 0 0 1 .67.158l.276.138a.75.75 0 1 0 .67-1.342l-.274-.137a3 3 0 0 0-1.342-.317H16.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5A1.5 1.5 0 0 0 1.5 3v18A1.5 1.5 0 0 0 3 22.5h18a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 21 1.5H3ZM21 3H3v18h18V3Z"
  })));
};

export default SvgSubtitles;